<template>
  <div id="fee_detail">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            檢視公告
          </div>
        </div>
        <div class="right">
          <el-button
            plain
            @click="isOpenReadDialog = true"
          >
            已讀紀錄
          </el-button>
          <el-button
            plain
            @click="isOpenHistoryDialog = true"
          >
            異動紀錄
          </el-button>
          <el-button
            plain
            :disabled="newsData.Status === ANN_STATUS.CREATING || newsData.Status === ANN_STATUS.DELETED"
            @click="$router.push({name:'newsEdit', query: { id: newsData.Id }})"
          >
            {{ newsData.Status === ANN_STATUS.PENDING_ADJUSTMENT ? $t('News.Adjust') : $t('News.Modify') }}
          </el-button>
          <el-button
            type="danger"
            plain
            :disabled="newsData.Status === ANN_STATUS.CREATING || newsData.Status === ANN_STATUS.DELETED"
            @click="delNews"
          >
            刪除
          </el-button>
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="feeDetailEdit"
          class="list"
          status-icon
          label-position="left"
        >
          <el-form-item label="標題">
            <template>{{ newsData.Title }}</template>
          </el-form-item>
          <el-form-item label="公告類型">
            <template>{{ newsData.TypeName }}</template>
          </el-form-item>
          <el-form-item
            label="公告起日"
            class="Interval"
          >
            <template>{{ newsData.Start }}</template>
          </el-form-item>
          <el-form-item
            label="公告訖日"
            class="Interval"
          >
            <template>{{ newsData.Due }}</template>
          </el-form-item>
          <el-form-item label="是否刊登">
            <div class="status-wrap" @click="showWarningDialog()">
              <template><span :class="`tag ${filteredStatus.css}`">{{ filteredStatus.text }}</span></template>
              <img
                v-if="newsData.Status === ANN_STATUS.PENDING_ADJUSTMENT"
                src="@/assets/img/announcement/exclamation-mark-roundedline.svg"
                alt="exclamation-mark-roundedline"
                class="exclamation-mark-roundedline"
              />
            </div>
          </el-form-item>
          <el-form-item label="是否置頂">
            <template>{{ newsData.IsTop == 2 ? "置頂中":"無" }}</template>
          </el-form-item>
          <el-form-item
            label="內容"
            class="Detail"
          >
            <template>
              <div
                class="unreset"
                v-html="newsData.cleanDetail"
              />
            </template>
          </el-form-item>
          <el-form-item label="附加檔案">
            <div v-if="newsData.Status !== 2" class="file-wrap">
              <a
                v-for="(file,file_ind) in newsData.Files"
                :key="file_ind"
                :href="file.ExpiringUrl || file.Url"
                class="file"
              >
                <div class="fileName">{{ `檔案${file_ind+1}` }}</div>
              </a>
            </div>
            <div v-else>
              {{ $t('News.NewsDetail.DeletedMsg') }}
            </div>
          </el-form-item>
          <el-form-item label="附加圖片">
            <div v-if="newsData.Status !== 2" class="file-wrap">
              <div
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                class="file"
                :style="{ backgroundImage: 'url(' + image + ')' }"
                @click="index = imageIndex"
              />
            </div>
            <div v-else>
              {{ $t('News.NewsDetail.DeletedMsg') }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomControl">
        <el-button class="bottom-btn" @click="$router.push({name:'news'})">
          返回公告列表
        </el-button>
      </div>
    </div>
    <CoolLightBox
      :items="images"
      :index="index"
      :slideshow="false"
      @close="index = null"
      @on-open="lightBoxOpen"
    />
    <NewsHistory v-model="isOpenHistoryDialog" :announcement-id="$route.params.id"></NewsHistory>
    <NewsRead v-model="isOpenReadDialog" :announcement-id="$route.params.id"></NewsRead>
    <NewsMessageDialog
      :visible.sync="isOpenNewsWarningDialog"
      :title="$t('News.NewsPendingTitle')"
      :confirm-button-text="$t('News.NewsPendingButton')"
      @confirm="handleWarningDialogConfirm"
    />
  </div>
</template>
<script>
import * as DOMPurify from 'dompurify'
import NewsHistory from './components/NewsHistory.vue'
import NewsRead from './components/NewsRead.vue'
import { ANN_STATUS } from '@/js/utils/announcementStatus'
import NewsMessageDialog from './components/NewsMessageDialog.vue'

export default {
  components: {
    NewsHistory,
    NewsRead,
    NewsMessageDialog
  },
  data () {
    return {
      ANN_STATUS,
      newsData: {
        Id: '',
        Title: '',
        Detail: '',
        Start: '',
        Due: '',
        Type: '',
        Status: 0,
        IsTop: 0,
        Files: [],
        ImageFiles: []
      },
      images: [],
      TypeList: [],
      index: null,
      isOpenHistoryDialog: false,
      isOpenReadDialog: false,
      isOpenNewsWarningDialog: false
    }
  },
  computed: {
    // 回傳狀態中文名稱
    filteredStatus () {
      if (!this.newsData.Id) {
        // 資料還未載入時先留空，增加使用者體驗
        return { text: '', css: '' }
      }
      switch (this.newsData.Status) {
      case ANN_STATUS.UNPUBLISHED:
        return { text: this.$t('News.Unpublished'), css: 'status-unpublished-tag' }
      case ANN_STATUS.ANNOUNCING:
        return { text: this.$t('News.Announcing'), css: 'status-announcing-tag' }
      case ANN_STATUS.DELETED:
        return { text: this.$t('News.Deleted'), css: 'status-deleted-tag' }
      case ANN_STATUS.CREATING:
        return { text: this.$t('News.Creating'), css: 'status-creating-tag' }
      case ANN_STATUS.PENDING_ADJUSTMENT:
        return { text: this.$t('News.PendingAdjustment'), css: 'status-pending_adjustment-tag' }
      case ANN_STATUS.EXPIRED:
        return { text: this.$t('News.Expired'), css: 'status-expired-tag' }
      case ANN_STATUS.RESERVED:
        return { text: this.$t('News.Reserved'), css: 'status-reserved-tag' }
      default:
        return { text: '', css: '' }
      }
    }
  },
  mounted () {
    this.GetNewsData()
    // this.getTypeList();
  },
  methods: {
    // 取得公告詳細
    GetNewsData () {
      const vobj = this
      const Authorization = this.$getCookie('comLoginToken').replace('token=', '')
      axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/v3/Detail`, {
        method: 'GET',
        params: { announcementId: vobj.$route.params.id },
        headers: {
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          Authorization
        }
      }).then(res => {
        const flag = res.data.Data
        vobj.newsData = {
          Id: flag.Id,
          Title: flag.Title,
          Detail: flag.Detail,
          cleanDetail: DOMPurify.sanitize(flag.Detail, { USE_PROFILES: { html: true } }),
          Start: flag.Start,
          Due: flag.Due,
          Type: flag.Type,
          TypeName: flag.TypeName,
          Status: flag.Status,
          IsTop: flag.IsTop,
          Files: flag.Files,
          ImageFiles: flag.ImageFiles
        }
        flag.ImageFiles.forEach((val) => {
          this.images.push(val.ExpiringUrl || val.Url)
        })
      }).catch(err => {
        /**
         * @function 處理取得公告詳細失敗的情況
         * @param {Object} err - 錯誤物件
         */
        try {
          // 檢查是否為公告不存在的錯誤代碼
          if (err.response?.data?.ErrorMessage?.Code === 400001) {
            // 顯示提示訊息，無取消按鈕，點擊確定後導回公告列表
            this.$alert('此公告不存在', '提示', {
              type: 'warning',
              showClose: false,
              confirmButtonText: this.$t('General.OK'),
              callback: () => {
                this.$router.push({ name: 'news' })
              }
            })
          } else {
            throw new Error('其他錯誤 throw 去 catch 顯示籠統文案')
          }
        } catch (e) {
          // 捕捉例外狀況
          this.$message.error(this.$t('Server.TryAgainLater'))
        }
      })
    },
    getTypeList () {
      this.modalLoading = true
      const KingnetAuth = 'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      axios(`${process.env.VUE_APP_CORE_URL}/api/CustomType/AnnouncementList`, {
        method: 'GET',
        // params: data,
        headers: {
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          KingnetAuth
        }
      }).then(res => {
        this.modalLoading = false
        if (res.status === 200) {
          this.TypeList = res.data.Data.List
          resolve(res.data.Data.List)
        } else {
          reject('error')
        }
      }).catch(err => {
        console.log(err.response)
      })
    },
    showLightbox (imageName) {
      this.$refs.lightbox.show(imageName)
    },
    // 刪除公告
    delNews (row_data) {
      const vobj = this
      const Authorization = this.$getCookie('comLoginToken').replace('token=', '')

      this.$confirm('公告刪除後將無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/v3/Delete`, {
          method: 'PUT',
          data: { Id: vobj.newsData.Id },
          headers: {
            'content-type': 'application/json',
            'cache-control': 'no-cache',
            Authorization
          }
        }).then(res => {
          vobj.$message({
            type: 'success',
            message: '刪除成功'
          })
          vobj.$router.push({ name: 'news' })
          vobj.$store.commit('ifNewsEdit', true)
        }).catch(err => {
          vobj.$message({
            type: 'info',
            message: err.response
          })
        })
      }).catch(() => {})
    },
    giveTypeName (typeNo, list) {
      let haveName = false
      for (const item of list) {
        if (item.Id === typeNo) {
          haveName = true
          return item.Name
        } else {
          haveName = false
        }
      }
      if (haveName === false) {
        return '類型已被刪除'
      }
    },
    lightBoxOpen () {
      if (document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]')) { document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]').style.display = 'none' }
    },
    showWarningDialog () {
      if (this.newsData.Status !== ANN_STATUS.PENDING_ADJUSTMENT) {
        return
      }
      this.isOpenNewsWarningDialog = true
    },
    handleWarningDialogConfirm () {
      this.isOpenNewsWarningDialog = false
      this.$router.push({
        name: 'newsEdit',
        query: {
          id: this.newsData.Id
        }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_detail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    .el-form-item
      display: flex
      align-items: flex-start
      width: 100%
      box-sizing: border-box
      +basicForm
      &.Interval
        width: 50%
      &.half
        width: 50%
      &__label
        font-weight: bold
        flex-basis: 105px
        vertical-align: top
        text-align: right
      &__content
        flex: 1
        // max-width: 400px
        .el-select,.el-date-editor
          width: 100%
        .file-wrap
          display: flex
          flex-wrap: wrap
          .file
            width: 150px
            height: 150px
            border: 1px solid #ccc
            color: #666
            border-radius: 4px
            cursor: pointer
            margin: 10px
            position: relative
            overflow: hidden
            background-position: center
            background-size: cover
            &:hover
              color: #333
              border: 1px solid #aaa
              box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
              transition: .4s
              .optionBtn-wrap
                bottom: 0
            i
              font-size: 60px
            .fileName
              font-size: 17px
              font-weight: 700
              width: 100%
              height: 100%
              line-height: 150px
              text-align: center
            .bg-img
              height: 100%
              width: 100%
              background-position: center
              background-size: cover
      &.Detail
        > .el-form-item__content
          line-height: initial
          width: 100%
          overflow: auto
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 70px 0 30px
    box-sizing: border-box
    +NewsStatusTag
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
  .bottom-btn
    border-radius: 66px
</style>
